<div class="header row align-items-center">
  <div class="col">
    <h3 class="m-y-0">{{'MENU.MANAGE-SELLER'|translate}}</h3>
  </div>
</div>


<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row">
    <div class="col h-50">
      <ng-select class="custom" id="name" [items]="sellerNames" placeholder="{{'FILTER.SELECT-SELLER-NAME'|translate}}"
                 [(ngModel)]="searchName" [ngClass]="{'selected': searchName || searchingName}"
                 (focus)="searchingName = true"
                 (blur)="searchingName = false">
      </ng-select>
      <label class="select-label" *ngIf="searchName || searchingName"
             for="name">{{'FILTER.SELECT-SELLER-NAME'|translate}}</label>
    </div>

    <div class="col h-50">
      <ng-select class="custom" id="taxID" [items]="sellerTaxIDs" placeholder="{{'FILTER.SELLER-TAX-ID'|translate}}"
                 [(ngModel)]="searchTaxID" [ngClass]="{'selected': searchTaxID || searchingTaxID}"
                 (focus)="searchingTaxID = true" (blur)="searchingTaxID = false">
      </ng-select>
      <label class="select-label" *ngIf="searchTaxID || searchingTaxID"
             for="taxID">{{'FILTER.SELLER-TAX-ID'|translate}}</label>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <div class="float-right" *ngIf="loading === false">
    <button type="button" class="btn btn-dv btn-wide"
            (click)="openModal(null)">{{'TEXT.ADD_SELLER' | translate}}</button>
  </div>
  <div class="m-t-50 add-seller-info" *ngIf="loading === false">
    {{'COMMON.ADD-SELLER-INFO' | translate}}
  </div>
  <div class="row m-t-20" *ngIf="sellerDetails.length === 0 && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>


  <div class="scrollable" style="clear: both">
    <table class="table text-center" *ngIf="sellerDetails.length !== 0 && !loading">
      <thead>
      <tr>
        <th scope="col">{{'NORMAL.QUE'| translate}}</th>
        <th scope="col">{{'ISSUE-TEXT.SELLER-NAME'| translate}}</th>
        <th scope="col">{{'TABLE.TAX-ID'| translate}}</th>
        <th scope="col">{{'TABLE.BRANCH-CODE'| translate}}</th>
        <th scope="col">{{'TABLE.BRANCH-NAME'|translate}}</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let seller of sellerDetails; let index = index">
        <td>{{ index + 1 }}</td>
        <td>{{ seller.name_th }}</td>
        <td>{{ seller.tax_id }}</td>
        <td>{{ seller.branch_code }}</td>
        <td>{{ seller.branch_name }}</td>
        <td>
          <i class="fa fa-1x fa-edit text-warning pointer m-r-5" (click)="openModal(seller)"></i>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller-manage/seller-manage.component.html